import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetStoreByID } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import DoubleField from "../../components/DoubleField";
import TextInputField from "../../components/TextInputField";
import TextAreaField from "../../components/TextAreaField";

const ViewStore = () => {
  let param = useParams();
  const navigate = useNavigate();
  const { currentColor } = useStateContext();
  // const [AllStock, setAllStock] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    tax: "0",
    // manager: "select",
    street_address: "",
    city: "",
    state: "",
    postal_code: "",
  });

  // const customersGrid = [
  //   {
  //     headerText: "Part ID",
  //     field: "part_id",
  //     width: "150",
  //     textAlign: "Center",
  //   },
  //   {
  //     headerText: "Part Name",
  //     field: "productname",
  //     width: "150",
  //     textAlign: "Center",
  //   },
  //   {
  //     field: "code",
  //     headerText: "Part Code",
  //     width: "150",
  //     textAlign: "Center",
  //   },
  //   {
  //     field: "unit_instock",
  //     headerText: "Stock",
  //     width: "150",
  //     textAlign: "Center",
  //   },
  //   { field: "unit", headerText: "Unit", width: "150", textAlign: "Center" },
  //   {
  //     field: "opening_balance",
  //     headerText: "Opening Balance",
  //     width: "150",
  //     textAlign: "Center",
  //   },
  // ];

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    navigate("/Stores");
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (param.Store_id) {
        // const resp = getAllPartByStoreID(param.Store_id);
        // resp.then(function (result) {
        //     if (result.data) {
        //       setAllStock(result.data || []);
        //     }
        //   })
        //  .catch((err) => console.log(err.message));
        await GetStoreByID(param.Store_id)
          .then((result) => {
            setFormData({
              name: result.data.name || "",
              email: result.data.email || "",
              phone: result.data.contact || "",
              tax: result.data.tax || "0",
              street_address: result.data.street_address || "",
              city: result.data.city || "",
              state: result.data.state || "",
              postal_code: result.data.postal_code || "",
              manager: result.data.manager || "select",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [param.Store_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW STORE" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>GENERAL INFORMATION</b>
                </div>
                <TextInputField
                  label="Name:"
                  name="name"
                  value={formData.name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Email:"
                  name="email"
                  value={formData.email}
                  placeholder="Email"
                  disabled
                />
                <TextInputField
                  label="Phone:"
                  name="phone"
                  value={formData.phone}
                  placeholder="Phone"
                  disabled
                />
                <DoubleField
                  label="Tax %:"
                  name="tax"
                  value={formData.tax}
                  placeholder="Tax"
                  disabled
                />
              </div>
            </Col>
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>LOCATION DETAIL</b>
                </div>
                <TextAreaField
                  label="Street Address:"
                  name="street_address"
                  value={formData.street_address}
                  placeholder="Street Address"
                  disabled
                />
                <TextInputField
                  label="City:"
                  name="city"
                  value={formData.city}
                  placeholder="City"
                  disabled
                />
                <TextInputField
                  label="State:"
                  name="state"
                  value={formData.state}
                  placeholder="State"
                  disabled
                />
                <TextInputField
                  label="Postal Code:"
                  name="postal_code"
                  value={formData.postal_code}
                  placeholder="Postal Code"
                  disabled
                />
              </div>
            </Col>
          </Row>
          {/* <Row xs={1} sm={1} className="p-0 justify-content-center">
            {AllStock.length > 0 && (
              <GridComponent
                className="custom-grid"
                dataSource={AllStock}
                allowPaging={true}
                pageSettings={{
                  pageSize: 16,
                  pageSizes: [16, 48, 100, "All"],
                }}
                height="calc(62vh - 60px)"
                allowSorting
                allowResizing
                rowHeight={36}
              >
                <ColumnsDirective>
                  {customersGrid.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))}
                </ColumnsDirective>
                <Inject
                  services={[Resize, Page, Toolbar, Selection, Sort, Filter]}
                />
              </GridComponent>
            )}
          </Row> */}
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewStore;
